import {
  GraduationCap,
  Globe,
  Clock3,
  BookOpen,
  Wallet,
  CalendarDays,
  DockIcon,
} from "lucide-react";

import { motion } from "framer-motion";

export default function InfoCards({
  titulo,
  modalidad,
  facultad,
  duracion,
  campo,
  inversion,
  inicio,
  resolucion,
}) {
  const cards = [
    { icon: GraduationCap, title: "Título", value: titulo },
    { icon: Globe, title: "Modalidad", value: modalidad },
    { icon: Clock3, title: "Duración", value: duracion },
    { icon: CalendarDays, title: "Facultad", value: facultad },
    { icon: BookOpen, title: "Campo amplio", value: campo },
    { icon: Wallet, title: "Inversión", value: inversion },
    { icon: CalendarDays, title: "Inicio", value: inicio },
    { icon: DockIcon, title: "Resolución", value: resolucion },
  ];

  // Verifica que el valor realmente tenga contenido
  const hasValue = (value) => {
    if (value === null || value === undefined) return false;

    // Strings
    if (typeof value === "string") {
      return value.trim() !== "";
    }

    // Arrays
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    // Otros valores
    return true;
  };

  const visibleCards = cards.filter((card) => hasValue(card.value));

  // Si no existe ningún valor, no renderizamos la sección
  if (visibleCards.length === 0) return null;

  return (
    <section className="bg-slate-50 px-4 py-4 md:py-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-2 md:gap-4 xl:grid-cols-3">
          {visibleCards.map((card, index) => {
            const Icon = card.icon;

            const isLastOdd =
              index === visibleCards.length - 1 &&
              visibleCards.length % 2 !== 0;

            return (
              <motion.div
                key={`${card.title}-${index}`}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.35,
                  delay: index * 0.05,
                }}
                className={`flex flex-col items-start gap-2 rounded-xl border border-slate-200 bg-white p-3 shadow-sm sm:flex-row sm:gap-4 md:rounded-2xl ${
                  isLastOdd ? "col-span-2 sm:col-span-1" : ""
                }`}
              >
                <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#004270]/10 sm:h-10 sm:w-10">
                  <Icon
                    size={18}
                    className="text-[#004270] sm:scale-110"
                    strokeWidth={2.3}
                  />
                </div>

                <div className="min-w-0 w-full flex-1">
                  <p className="truncate text-[9px] font-bold uppercase tracking-wider text-slate-500 sm:text-[10px]">
                    {card.title}
                  </p>

                  <div
                    className="
                      mt-0.5 break-words font-medium text-[#004270]
                      [&_p]:text-base
                      [&_p]:font-medium
                      [&_p]:leading-none
                      [&_h3]:text-sm
                      [&_h3]:p-0
                      [&_h3]:font-medium
                    "
                  >
                    {card.value}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}